import { FieldType } from '@interfaces/global/config-global';
import { FormSettingsType } from '@components/Form';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    name: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .max(50, 'MAXLENGTH'),
    username: yup.string()
        .required('REQUIRED')
        .matches(/^[a-zA-Z0-9.-_]*$/, 'DISTRIBUTOR_CODE_INVALID')
        .min(3, 'MINLENGTH')
        .max(50, 'MAXLENGTH'),
    email: yup.string()
        .required('REQUIRED')
        .email('EMAIL')
})

export const UserSearchForm: FormSettingsType = {
    submitOnKeyEnter: true,
    fields: [
        {
            type: 'search',
            name: 'usersSearch',
            placeholder: 'form.placeholders.usersSearch',
            addorn: {
                rightIcon: 'search',
            },
        },
    ],
};

export default class UserFormExtra {

    userForm = (f: any, editing?: boolean) => {

        const fields = [
            {
                type: 'text',
                className: 'hidden',
                name: 'id',
                label: '',                
            },
            {
                type: 'text',
                className: 'hidden',
                name: 'createdAt',
                label: '',                
            },
            {
                type: 'text',
                name: 'name',
                label: 'form.labels.name',
                maxLength: 50,
            },
            {
                type: 'text',
                name: 'username',
                label: 'form.labels.username',
                maxLength: 50,
                disabled: editing ? editing : false
            },
            {
                type: 'email',
                name: 'email',
                label: 'form.labels.email',
            },
            {
                type: 'masked',
                name: 'phone',
                label: 'form.labels.phone',
                labelAddorn: 'form.labels.optional',
                mask: [
                    '+',
                    /[1-9]/,
                    /\d/,
                    ' ',
                    '(',
                    /[1-9]/,
                    /\d/,
                    ')',
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    '-',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ],
            },
        ];

        f.map((item: any) => {
            const fieldType = String(FieldType[item.type]).toLowerCase();

            const fieldObject = {
                type: fieldType,
                name: item.id,
                label: item.name,
                labelAddorn: 'form.labels.optional',
                mask: [],
                // disabled: false,
                hideClearButton: true,
                initialValue: item.value,
            }
            if (item.value !== null) {
                fieldObject['items'] = item.value;
                //TODO: placeholder correto
                fieldObject['placelhoder'] = "Selecione um valor";
                fieldObject['optionLabel'] = 'label';
                fieldObject['optionValue'] = 'value';
            }

            fields.push(fieldObject);
        });

        const form = {
            validationSchema: validationSchema,
            fields: fields,
            submitButtonText: editing ? 'common.save' : 'common.register'
        };

        return form;
    }
}
